import AppHeader from '../AppHeader'
export default {
  name: 'video-customer-service',
  created () {
    window.scrollTo(0, 0)
  },
  computed: {
  },
  components: {
    AppHeader
  },
  methods: {
    goVideoCategories: function() {
      this.$router.push({ path: '/video_categories'})
    },
    poster: function(image) {
      let reset_url = location.href
      return reset_url.substr(0, reset_url.lastIndexOf("#")) +'static/videosimage/' + image + '.png'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/video-customer-service.js